import React from 'react';
import { noop } from 'lodash';
import { EllipsisIcon } from '@fiverr-private/visuals';
import { Popover, PopoverAnchor, PopoverChevron, PopoverContent } from '@fiverr-private/popover';
import { Stack } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { ENTITY_TYPE, LazyReportContentModal, ReportingContextProvider } from '@fiverr-private/content_reporting';
import { ActionCtaBase } from '../ActionCtaBase';
import { ReportGigItem } from './ReportGigItem';

export const ShowMoreCta: React.FC = () => {
  const {
    currentUser,
    general: { gigId, sellerId },
  } = useGigPageContext();

  const isRestricted = currentUser?.status === 'restricted';

  if (isRestricted) {
    return null;
  }

  return (
    <ReportingContextProvider entityId={`${gigId}`} entityType={ENTITY_TYPE.GIG} sellerId={`${sellerId}`}>
      <Popover position="bottom">
        <PopoverAnchor>
          <ActionCtaBase onClick={noop} dataTestId="show_more_test_id">
            <EllipsisIcon />
          </ActionCtaBase>
        </PopoverAnchor>
        <PopoverContent disablePadding renderWhenClosed>
          <PopoverChevron />
          <Stack margin="2" direction="column">
            <ReportGigItem />
          </Stack>
        </PopoverContent>
      </Popover>
      <LazyReportContentModal />
    </ReportingContextProvider>
  );
};
